import clsx from 'clsx';

import { Box } from '../../Box/Box';

import {
  cellTrigger,
  cellTriggerNoSpace,
  discoverable,
  discoverableNoSpace,
  headerTrigger,
  headerTriggerNoSpace,
  rowTrigger,
  rowTriggerNoSpace,
} from './styles.css';

export type Props = {
  trigger?: 'row' | 'cell' | 'header';
  children: React.ReactNode;
  /**
   * When true, the component won't take up any space when hidden (uses display: none)
   * When false (default), the component preserves space when hidden (uses visibility: hidden)
   */
  noSpaceWhenHidden?: boolean;
};

export const Discoverable: React.FC<Props> = ({ children, trigger = 'cell', noSpaceWhenHidden = false }) => (
  <Box
    display="flex"
    cssClass={clsx(noSpaceWhenHidden ? discoverableNoSpace : discoverable, {
      [noSpaceWhenHidden ? rowTriggerNoSpace : rowTrigger]: trigger === 'row',
      [noSpaceWhenHidden ? cellTriggerNoSpace : cellTrigger]: trigger === 'cell',
      [noSpaceWhenHidden ? headerTriggerNoSpace : headerTrigger]: trigger === 'header',
    })}
  >
    {children}
  </Box>
);
